<template>
    <div style="width:100%;height:100%;overflow-y:auto;overflow-x:hidden; ">
        <div style="display:flex; height:35px;margin-bottom:6px">
            <div style="line-height:30px;height:30px;font-size:12px;width:90px">物料编码：</div>
            <span style="font-weight:600;font-size:12px;line-height:30px;color:#389">{{v_row['MATNO']}}  </span>
            <div style="line-height:30px;height:30px;font-size:12px;width:90px;margin-left:20px; ">物料名称：</div>
            <div style="font-weight:600;font-size:12px;line-height:30px;color:#389;min-width:100px">{{v_row['MATNM']}}</div>
        </div>
        <div class="one-toolbar">
            <el-button  @click="dtlAdd" type="primary" plain size="mini" style="height:27px;margin-top:3px;margin-left:10px;border:1px solid green">
                <i class="iconfont icon-xinzeng" style=" font-size:12px;margin-right:3px"></i>新增记录
            </el-button>
            <el-button  @click="saveRec" type="success" plain size="mini" style="height:27px;margin-top:3px;margin-left:30px;border:1px solid green">
                <i class="iconfont icon-baocun" style=" font-size:12px;margin-right:3px"></i>保存记录
            </el-button>
        </div>        
        <el-table  :data="dtlData" 
            border                            
            size="small"
            ref="refdtl"
            :header-cell-style="{'height':'20px'}"
            cell-class-name="clearPadding"
            :cell-style="{padding:'2px'}"
            style="margin-top:-8px; font-size:12px"
            :height="400" 
            v-loading="v_loading"
            :element-loading-text="$LANG('1959', '加载中')"
            element-loading-spinner="el-icon-loading"
            element-loading-background="rgba(255, 251, 255, 0.8)"
            class="custom-table-border"
            highlight-current-row >  
            <el-table-column label="序号" type="index" width="60"></el-table-column>
            <el-table-column  v-for="(item ) in dtlCol.filter(item=>item.thide=='N')" :key="item.key"
                :prop="item.key"
                :label="item.title"
                show-overflow-tooltip
                :align="item.align"                                  
                :sortable="item.edcss!=='checkbox'&&item.sortable=='N'"
                :min-width="item.width">
                <template slot="header"><span v-if="item.notnull=='Y'" style="color:red">{{item.title}}</span></template>
                <template slot-scope="scope"> 
                    <el-date-picker v-if="item.edcss=='date'" placeholder="请选择 " size="mini" type="date" clearable v-model="scope.row[item.key]" value-format="yyyy-MM-dd" style="width:100%"></el-date-picker>
                    <el-input type="textarea" :rows="2"  clearable  v-else-if="item.key=='RMK'" size="mini" v-model="scope.row[item.key]" style="border:1px solid #389" > </el-input>     
                    <el-input  v-else-if="item.disabled=='N' " size="mini" v-model="scope.row[item.key]" style="width:100%"> </el-input> 
                    
                    
                    <span v-else  v-text="scope.row[item.key]" style="width:100%"> </span> 
                </template> 
            </el-table-column> 
            <el-table-column
                
                label="操作"
                align="center"
                width="80">
                <template slot-scope="scope"> 
                    <i class="iconfont icon-shanchu" style="color:#409EFF;font-size:12px;margin-right:3px;"></i>
                    <el-link   @click="dtlDel(scope.row,scope.$index)" :underline="false"  ><span style="font-size:11px;margin-right:2px;">删除</span> </el-link>
                </template>
            </el-table-column>
        </el-table> 
     
     
        <!-- 提示框 -->
        <el-dialog v-dialogDrag :visible.sync="promptWin"  width="450px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">提示</span>
            </div>
            <div style="line-height:30px;display:flex">
                <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
            </div>
            <span slot="footer"  >
                <el-button type="primary" size="small" @click="promptWin = false">确 定</el-button>
            </span>
        </el-dialog>
   
        <!-- 编辑框 -->
        <el-dialog  v-dialogDrag   :visible.sync="editWin" width="1200px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="6vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">编辑框</span>
            </div> 
            <el-input type="textarea" :rows="10" placeholder="请输入内容" v-model="v_rmk"> </el-input>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px;  ">
                <span style="float:right">
                    <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="editWin=false" style="margin-right:50px;">取消</el-button>
                    <el-button type="primary" size="small" icon="iconfont icon-chenggong1"  @click="rmkOk" style="margin-right:10px;">确定</el-button>         
                </span>
            </div>
        </el-dialog> 
    
    </div>
</template>
<script>
 
import { getTabColOrData,getBaseData } from '../../api/user'
import {getDate,getWeek} from '../../api/Select' 
 
    export default {
        name:"waiting_log",
        props: {
            v_row: {}, // 渲染数据
          
        },
        data() {
            return {
                editWin:false,
                v_rmk:'',
                v_index:'',
                timeArr:[],
              
                logWin:false,
                promptWin:false,
                prompt:'',
                uploadUrl: '/xuper_oss/ftpUpload_nocheck' ,
                Accept: "png,jpg,jpeg,gif,tiff,pdf,xls,xlsx,doc,docx",
                saveFlag:true,
                rmkArr:[],
                v_loading:false,
                v_username:this.$cookies.get('v_telno'), //api 请求用户
                
                v_corpid:this.$cookies.get('v_corpid') ,//api 请求密码
                v_url: 'xuper_auth/getTableRecMany',
                defaultDate:'',
                v_mth:'',
                v_dttm:'',
                year:'',
                dayWin:false,
                v_idseq:'',
              
                dtlCol:[],
                dtlData:[],
                mainRow:{},
                v_usernm:this.$cookies.get('v_usernm'), //api 请求用户
                delDtlArr:[],
                chkIndex: 0,
   
                imgData:[],
                fileName:'',
                delImg:[],
                v_table:'',
                tableCol :[],
                v_key2 :'',
                v_value2 :'',
                btnWin:false,
                v_key:'',
                t_cond:'',
             
                v_tabIndex:'',
                v_tabrow:{},
                v_random:'',
                dayArr:[],
                v_commit :true,
   
                v_week:'',
                v_lang:this.$store.state.lang,
            }
        },
        mounted () {
            // getBaseData('xuper_auth/getBaseData','userno',this.v_username,'','','v_sys_user','').then(res=>{
            //     this.v_out =res.result[0]['ISOUT']
            // })
        },
        created () {
            if (this.v_username){ 
             
                this.getTabField()

            }else{
                let routeUrl = this.$router.resolve({
                    path: '/login',
                    query: {},
                });
                window.open(routeUrl.href, '_self');
            }
        },
        watch: {
            dtlData: {
                handler() {
                    this.$nextTick(() => {
                        this.$refs['refdtl'].doLayout()     
                    })
                },
                deep: true
            },
     
        },
        components: {
 
        },
        computed:{
   
        },
        methods: {
            getTabList(){
                this.dtlData =[]
                this.v_loading =true    
                getTabColOrData(this.v_url,'v_wait_task','refidseq',this.v_row['IDSEQ'],'reflstseq',this.v_row['LSTSEQ'],'','',' order by adddttm' ).then((res) => { 
                    this.dtlData =res.result 
                    this.$nextTick(()=>{
                        this.$refs['refdtl'].doLayout()
                        this.v_loading =false
                    })
                })
            },
      
            rmkOk(){
                this.dtlData.splice(this.v_index,1,Object.assign(this.v_tabrow,{RMK:this.v_rmk}))
                this.editWin =false
            },
            inputBtn( row, index, key){
 
                if (key =='RMK'){
                    this.v_rmk =row['RMK']
                    this.v_index =index
                    this.v_tabrow =JSON.parse(JSON.stringify(row))
                    this.editWin =true

                } 
            },
            //预览PDF
            pdfViewer(path){
                let routeUrl = this.$router.resolve({
                    path: '/fullPreview',
                    query: {fileUrl: path},
                });
                window.open(routeUrl.href, '_blank');
            },
            //图片删除，操作数组
            imgDel(item,index){
                if(item['IDSEQ'] && item['LSTSEQ']){
                    
                    this.$axios({
                        method: 'post',
                        url:'xuper_auth/getBaseData',
                        data: {p_key:'refidseq',p_value:item['IDSEQ'],p_key2:'reflstseq',p_value2:item['LSTSEQ'],p_table:'V_MAT_IMG'},
                    }).then(res=>{  
                        //console.log(item['IDSEQ'],item['LSTSEQ'],res.result.length)
                        if(res.result.length>0 && res.result){
                            let v_idno =res.result[0]['MATIDNO']
                            this.promptWin =true
                            this.prompt ='此附件已被编码：'+v_idno+'引用，如需删除此图片请先删除引用的图片'
                        }else{
                            this.$confirm('你确定要删除此图片吗','提示',{
                                confirmButtonText: '确定',
                                cancelButtonText:'取消',
                                customClass:'messageBox',
                                showClose:false,
                                closeOnClickModal:false,
                                closeOnPressEscape:false,
                                type:'info',
                            }).then(()=>{
                                this.delImg.push({IDSEQ:item['IDSEQ'],LSTSEQ:item['LSTSEQ'],FILEPATH:item['FILEPATH'],PATH:item['PATH']}) 
                                this.imgData.splice(index, 1);    
                            }).catch(()=>{})
                        }
                    })
                }else{
                    this.$confirm('你确定要删除此图片吗','提示',{
                        confirmButtonText: '确定',
                        cancelButtonText:'取消',
                        customClass:'messageBox',
                        showClose:false,
                        closeOnClickModal:false,
                        closeOnPressEscape:false,
                        type:'info',
                    }).then(()=>{
                        this.delImg.push({IDSEQ:item['IDSEQ'],LSTSEQ:item['LSTSEQ'],FILEPATH:item['FILEPATH'],PATH:item['PATH']}) 
                        this.imgData.splice(index, 1);    
                    }).catch(()=>{})
                }
            },
      
            dtlAdd(){
                let v_dtlrow ={}
                this.dtlCol.forEach(item=>{
                    v_dtlrow[item.key] =''
                })
                v_dtlrow['REFIDSEQ'] =this.v_row['IDSEQ']    
                v_dtlrow['REFLSTSEQ'] =this.v_row['LSTSEQ']  
                v_dtlrow['CORPID'] =this.v_corpid
                v_dtlrow['REFIDTY'] ='POREQ' 
                this.dtlData.push(v_dtlrow)
                this.delDtlArr=[]
                this.$nextTick(()=>{
                    setTimeout(() => {
                       this.$refs['refdtl'].doLayout()     
                    }, 200)
                    
                }) 
            },
            //明细编辑、删除
            dtlDel(row,index){
                this.delDtlArr.push(row)
                this.dtlData.splice(index,1 )
            },
            //保存记录
            saveRec(){
                let obj_ ={}, v_title='' ,v_amt=0
                // 明细记录非空校验
                this.dtlData.forEach(item => {
                   this.dtlCol.filter(item =>item.notnull=='Y').some(it =>{
                       if (!item[it.key]){
                           v_title =it['title']
                           return true
                       }
                   }) 
                }) 
                if (v_title){
                    this.promptWin =true
                    this.prompt =v_title +'不能为空'
                }else if (this.dtlData.length ==0){
                    this.promptWin =true
                    this.prompt = '明细记录不能为空'
                }else{
                    if ( this.v_commit){
                        this.v_commit =false
                        //明细保存：批量保存  res.idseq
                        this.$axios({   
                            method: 'post',
                            url:'xuper_auth/batDtlSave2',
                            data: {p_json:JSON.stringify(this.dtlData), p_table:'WAIT_TASK',p_idseq:1,p_action:'S' },
                        })
                        //明细删除
                        if (this.delDtlArr.length>0) {
                            this.$axios({   
                                method: 'post',
                                url:'xuper_auth/batDtlSave2',
                                data: {p_json:JSON.stringify(this.delDtlArr), p_table:'WAIT_TASK',p_idseq:1,p_action:'D' },
                            })
                        } 
                        this.$message({
                            message: '保存成功',
                            type: 'success',
                            duration: 2000
                        })   
                    }
                }
            },
 
            //获取表列字段
            getTabField(){
                let vm =this    
                getTabColOrData(this.v_url, 'v_sys_form_fld','idseq','101','lstseq','4','','',' order by sortby,itmseq').then((res) => {
                    for (let k=0; k<res.result.length; k++){
                        vm.dtlCol.push({ //向数组的开头 添加序列号
                            title: res.result[k].title,
                            key: res.result[k].key,
                            align: res.result[k].align,
                            width: res.result[k].width,
                            thide:res.result[k].THIDE,
                            fhide:res.result[k].FHIDE,
                            edcss:res.result[k].EDCSS,
                            disabled:res.result[k].DISABLED,
                            dotnum:res.result[k].DOTNUM,
                            sortable:res.result[k].SORTABLE,
                            notnull:res.result[k].NOTNULL,
                        })
                    }
                })
        
            }
        },
  }
</script>
 
<style scoped lang="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .css_obj{
        position: absolute;
        right: 5px;
        top: 5px;
        z-index: 99;
        font-size: 12px;
        display:flex;
    }
    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 1px auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
    .item-width  {
        width: 32%;
        min-width:200px;
    }
    .app-container {
        height:calc(100vh -100px);/*页面高度减120px*/
        display:flex;
        flex-direction:column;
        overflow-y:auto;
    }
    ::v-deep .calendar-pro__body {
        flex:1;
        height: 100%;
    }
    ::v-deep .calendar {
        height: 100%;
        display:flex;
        flex-direction:column;
    }
    ::v-deep .calendar-pro__body table {
        border-collapse: collapse;
        height: 100%;
    }
</style>
 